import type { ReactNode } from 'react'
import type {
  TooltipContentProps,
  TooltipProps as RadixTooltipProps,
  TooltipProviderProps as RadixTooltipProviderProps
} from '@radix-ui/react-tooltip'

export const TooltipColor = {
  light: 'light',
  dark: 'dark'
} as const

export type TooltipProps = {
  content: ReactNode
  providerProps?: Omit<RadixTooltipProviderProps, 'children'>
  rootProps?: RadixTooltipProps
  color?: keyof typeof TooltipColor
  disabled?: boolean
  isError?: boolean
  showArrow?: boolean
  hasProvider?: boolean
} & Omit<TooltipContentProps, 'content'>
